// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_Accordion__1Q927","Accordion__item":"Accordion_Accordion__item__2HYIN"};